import { PropertyCommonsProps } from '@/custom-types'
import { useUserLanguage } from '@/customHooks'



import balcony from '@/assets/property-icons/balcony-icon.svg'
import patio from '@/assets/property-icons/patio-icon.svg'
import commonBathroom from '@/assets/property-icons/bathroom-icon.svg'
import kitchen from '@/assets/property-icons/kitchen-icon.svg'
import elevator from '@/assets/property-icons/elevator-icon.svg'
import commonAirConditioner from '@/assets/property-icons/ac-icon.svg'
import commonFan from '@/assets/property-icons/fan-icon.svg'

type PropertyCommonsInfoCardProps = {
  data: PropertyCommonsProps
}

const textsData = {
  en: {
    noData: 'No Commons has been added',
    cards: {
      balcony: 'Balcony',
      patio: 'Patio',
      commonBathroom: 'Common Bathroom',
      kitchen: 'Kitchen',
      elevator: 'Elevator',
      commonAirConditioner: 'Common A/C',
      commonFan: 'Common Fan',
    },
  },
  es: {
    noData: 'No se han agregado cosas comunes en la propiedad',
    cards: {
      balcony: 'Balcón',
      patio: 'Patio',
      commonBathroom: 'Baño Común',
      kitchen: 'Cocina',
      elevator: 'Ascensor',
      commonAirConditioner: 'A/A Común',
      commonFan: 'Ventilador',
    }
  }
}

const iconMap: Record<string, string> = {
  balcony,
  patio,
  commonBathroom,
  kitchen,
  elevator,
  commonAirConditioner,
  commonFan,
};

export const PropertyCommonsInfoCard = ({ data }: PropertyCommonsInfoCardProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en
  
  const options = Object.entries(data).filter(([, value]) => value === true)
  
  if (options.length === 0) {
    return (
      <p><b>{texts.noData}</b></p>
    )
  }

  return (
    <div className='rounded-2xl bg-white p-6 shadow-[0_4px_12px_rgba(0,0,0,0.08)]'>
      <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'>
        {options.map(([name]) => (
          <div
            key={name}
            className='group flex min-h-[132px] cursor-pointer flex-col items-center justify-center rounded-xl border border-transparent bg-slate-50 px-6 py-5 text-center shadow-[0_2px_8px_rgba(0,0,0,0.12)] transition-all duration-200 ease-out hover:-translate-y-1 hover:scale-[1.02] hover:border-[#00356b]/15 hover:bg-white hover:shadow-[0_8px_22px_rgba(0,53,107,0.18)]'
          >
            <img
              src={iconMap[name]}
              alt={texts.cards[name as keyof typeof texts.cards]}
              width='40'
              height='40'
              className='transition-transform duration-200 ease-out group-hover:scale-110'
            />
            <span className='mt-3 text-base font-medium text-[#555] transition-colors duration-200 group-hover:text-[#00356b]'>
              {texts.cards[name as keyof typeof texts.cards]}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}